var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-tabs',{ref:"dynamicTabs",attrs:{"tabs-id":"user-purchases-tabs","tabs":_vm.tabs,"relevant-url-part-offset":_vm.relevantUrlPartOffset}})
}
var staticRenderFns = []

export { render, staticRenderFns }